import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import { API_BASE_URL, UPDATE_USER } from '../../../Config';

const EditUser = ({ userObj }) => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [formData, setFormData] = useState({});
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [selectedEmpRole, setSelectedEmpRole] = useState(null);
    const [rolesDDL, setRolesDDL] = useState([]);

    useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      const rolesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Roles'));

      if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserDataSession(userData);
        setRolesDDL(rolesData);

      } else {
        console.log("User data not found in sessionStorage");
      }
    }, []);
    
    useEffect(() => {
        if (userObj) {
            setFormData({
                OrgId: userDataSession.OrgId,
                Id: userObj.Id,
                Name: userObj.Name,
                Email: userObj.Email,
                Mobile: userObj.Mobile,
                IsMobile: userObj.IsMobile ? 1 : 0,
                Type: userObj.Type,
                UpdatedBy: userDataSession.UserId,
                IsActive: 1,
                RoleId: userObj.RoleId
            });

            setSelectedEmpRole(userObj.RoleId);
        }
    }, [userObj]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        formData.RoleId = selectedEmpRole ? selectedEmpRole : userObj.RoleId;

        console.log(formData, 'data sending to api');
        fetch(`${API_BASE_URL}${UPDATE_USER}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data, 'resposneeee');
                setSubmitBtnLoading(false);
                if (data.ResultData[0].Status === 'Success') {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: `Staff updated Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error('Error updating staff:', error);
            });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleEmpRoleChange = (selectedOption) => {
        setSelectedEmpRole(selectedOption.target.value);
        setFormData(prevState => ({
            ...prevState,
            Type: selectedOption.target.value
        }));
    };

    const handleIsMobileChange = (e) => {
        const isChecked = e.target.checked;
        setFormData({
            ...formData,
            IsMobile: isChecked ? 1 : 0
        });
    };    

    return (
        <div>
            {/* Edit User */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightUserEdit"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px', maxWidth: '40%' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Edit User</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder='Enter staff name'
                                    name="Name"
                                    value={formData.Name || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder='Enter email'
                                    name="Email"
                                    value={formData.Email || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Mobile No</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder='Enter mobile no'
                                    name="Mobile"
                                    value={formData.Mobile || ''}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                <label className="form-label">Employee Role</label>
                                <select
                                    className='form-select'
                                    value={selectedEmpRole}
                                    onChange={handleEmpRoleChange}
                                >
                                    <option>Choose employee role</option>
                                    {rolesDDL && rolesDDL.map((item, index) => (
                                        <option key={index} value={item.ItemId}>{item.ItemValue}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-6">
                                <div className="input-blocks d-flex">
                                    <div className="pass-group me-2">
                                        <input
                                            type="checkbox"
                                            id="mobileacc"
                                            checked={formData.IsMobile === 1}
                                            onChange={handleIsMobileChange}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                    <label htmlFor='mobileacc'>Mobile Access</label>
                                </div>
                            </div>
                            <div className="modal-footer-btn">
                                <button
                                    type="button"
                                    className="btn btn-cancel me-2"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-submit"
                                >
                                    {submitBtnLoading ? 'Submitting..' : 'Submit'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

EditUser.propTypes = {
    userObj: PropTypes.object.isRequired,
};

export default EditUser
